module.exports = __webpack_public_path__ + "img/chateau_vecquee_vue.ea972dcd.jpg";